import { lazy } from 'react';
import { type RouteConfigExtended, TabValue, studentPracticeSequencePath } from '@lingoda/router';

const SequencePage = lazy(() => import('./page/Page/Page'));

export const practiceSequenceRoutes: RouteConfigExtended[] = [
    {
        exact: true,
        component: SequencePage,
        path: studentPracticeSequencePath.raw,
        label: 'Lingobites',
        config: {
            hideHeader: true,
            hideFooter: true,
            hideDixa: true,
            hideMobileBottomNavbar: true,
            tab: TabValue.Practice,
            hideNotifications: true,
        },
    },
];
